import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initializeAdSenseAds } from "./utility/googleAds";

const scrollWindowToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const getProfileUid = (path = "") => {
  const match = path.match(/^\/User\/([^/]+)/i);
  return match ? match[1] : null;
};

const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();
  const previousPathnameRef = useRef(pathname);

  const isSameProfileTabSwitch =
    previousPathnameRef.current !== pathname &&
    Boolean(getProfileUid(previousPathnameRef.current)) &&
    getProfileUid(previousPathnameRef.current) === getProfileUid(pathname);

  useEffect(() => {
    previousPathnameRef.current = pathname;
  }, [pathname]);

  useEffect(() => {
    if (isSameProfileTabSwitch) return undefined;

    scrollWindowToTop();

    const rafId = requestAnimationFrame(scrollWindowToTop);
    const timeoutId = setTimeout(scrollWindowToTop, 0);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [pathname, search, key, isSameProfileTabSwitch]);

  useEffect(() => {
    if (isSameProfileTabSwitch) return undefined;

    const timeout = setTimeout(() => {
      initializeAdSenseAds();
    }, 400);

    return () => clearTimeout(timeout);
  }, [pathname, search, key, isSameProfileTabSwitch]);

  return null;
};

export default ScrollToTop;
